import {
  core_apimessages_AddressEntry as IAddressEntry,
  core_apimessages_Address as IAddress,
} from '../../schemas/rql';
import {  IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

export interface IAddressFormData extends IAddressEntry {
  uuid: string;
  primary: boolean;
}

export const buildBlankAddressFormData = (user: IUser): IAddressFormData => {
  return {
    uuid: '',
    name: '',
    streetAddress: '',
    extendedAddress: '',
    postalCode: '',
    phone: '',
    region: '',
    locality: '',
    countryCode: user.countryCode,
    primary: false,
  };
};

export const buildAddressFormDataFromAddress = (address: IAddress): IAddressFormData => {
  return {
    uuid: address.uuid,
    name: address.name,
    streetAddress: address.streetAddress,
    extendedAddress: address.extendedAddress,
    postalCode: address.postalCode,
    phone: address.phone,
    region: address.region,
    locality: address.locality,
    countryCode: address.countryCode,
    primary: address.primary,
  };
};
